import APIService from '../api.service';

export const List = (params) => {
  return APIService.get(`/v01/warehouse-consumptions`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
      start_date: params.startDate,
      end_date: params.endDate,
      status: params.status,
      warehouse_id: params.warehouse_id,
      consumption_type_id: params.consumption_type_id,
    },
  });
};

export const Create = (body, config = {}) => {
  return APIService.post(`/v01/warehouse-consumptions`, body, config);
};

export const Put = (payload, config = {}) => {
  const { id } = payload;
  return APIService.put(`/v01/warehouse-consumptions/${id}`, { ...payload }, config);
};

export const Delt = (id, config = {}) => {
  return APIService.delete(`/v01/warehouse-consumptions/${id}`, config);
};

export const Detail = (id) => {
  return APIService.get(`/v01/warehouse-consumptions/${id}`);
};

export const ProductOptions = (params = {}, config = {}) => {
  return APIService.get(`/v01/warehouse-consumptions-products`, { params, ...config });
};

const WarehouseConsumptionService = {
  List,
  Create,
  Put,
  Delt,
  Detail,
  ProductOptions,
};

export default WarehouseConsumptionService;
